export default {"src":"/_next/static/media/google-play-badge.f97c6a02.svg","height":64,"width":216,"blurWidth":0,"blurHeight":0};